import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { FilterFormModal, FilterValue } from 'src/app/models/form-group.model';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'fury-email-usage-zone',
  templateUrl: './email-usage-zone.component.html',
  styleUrls: ['./email-usage-zone.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation]
})
export class EmailUsageZoneComponent implements OnInit {

  selectConfig = {disableOptionCentering: true,panelClass: 'custom-class'}
  @Input()
  columns = [
    { name: 'Email Id', property: 'emailAddress', visible: true, isModelProperty: true },
    { name: 'Email Id Usage', property: 'emailAddressUsage', visible: true, isModelProperty: true },
    { name: 'Actions', property: 'actions', visible: true }
  ];  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  itemList: any;
  filterValue: any;
  pageSize = 30;
  totalCount: number = 0;
  pageIndex: number = 0;
  searchedKeyword!: string;
  searchBy: string = 'emailAddress';
  searchType: string = 'contains';
  isShowFilter: boolean = false;

  filterForm = new FormGroup<FilterFormModal>({
    searchBy: new FormControl(this.searchBy),
    searchType: new FormControl(this.searchType),
  });
  
  constructor(
    private apiservice: ApiService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public commonService: CommonService,
  ) {
    this.filterValue = 'Email Usage';
    this.activatedRoute.queryParams.subscribe((res: any) => {
      this.pageIndex = res.page ? res.page - 1 : 0;
      this.searchedKeyword = res.keywords ? res.keywords : '';
      this.pageSize = res.size ? (res.size === 'all' ? 9999 : res.size) : 30;  
      this.searchBy = res.searchBy ? res.searchBy : 'emailAddress';
      this.searchType = res.searchType ? res.searchType : 'contains';
      this.filterForm.patchValue({
        searchBy: this.searchBy,
        searchType: this.searchType
      });      
    });
  }
  get visibleColumns() {
    return this.columns.filter(column => column.visible).map(column => column.property);
  }
  ngOnInit(): void {
    this.getLeadRequestList();
  }

  pageSizeChange(event: any) {    
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.router.navigateByUrl(`/security/view-all-lead-requests/email-usage-list?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
    this.getLeadRequestList();
  }
  getLeadRequestList() {
    this.apiservice.get(`admin/security/lead-posting-filter/get-email-address-usage?page=${this.pageIndex + 1}&size=${this.pageSize}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}&type=all&searchBy=${this.searchBy}&searchType=${this.searchType}`).subscribe((res: any) => {
      if (res.body) {
        if (res.body?.emailAddressUsage?.data) {
          this.itemList =res.body?.emailAddressUsage?.data;
          this.totalCount = res.body.emailAddressUsage?.total;
          this.dataSource = new MatTableDataSource(this.itemList);
          this.cdr.detectChanges();
        } else {
          this.itemList = undefined;
        }
      }
    });
  }

  onFilterChange(value: string) {
      this.pageIndex = 0;
      this.searchedKeyword = value.trim();
      this.router.navigateByUrl(`/security/view-all-lead-requests/email-usage-list?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
      this.getLeadRequestList();
  }

  redirectToViewRequestsPage(row: any) {   
    this.router.navigateByUrl(`/security/view-all-lead-requests/view-all-lead-requests-list?page=1&keywords=${row.emailAddress}&size=${row.emailAddressUsage}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
  };

  showFilter(){
    this.isShowFilter = !this.isShowFilter; 
  }
  serchByValue: FilterValue[] = [
    {title: 'Email Address', value: 'emailAddress'},
  ];
  filterChange(){
    this.searchType = this.filterForm.value.searchType;
    this.searchBy = this.filterForm.value.searchBy;
    this.router.navigateByUrl(`/security/view-all-lead-requests/email-usage-list?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
    this.isShowFilter = false;
    this.getLeadRequestList();
  }


}
